import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { UserAvatar } from './UserAvatar';
import type { Identity } from './types';

/** Defines the large profile-header identity block options. */
export interface ProfileIdentityBlockProps {
  /** Supplies the canonical identity data to render. */
  identity: Identity;
  /** Sets the rendered profile avatar size. */
  avatarSize?: number;
  /** Renders optional controls alongside the identity block. */
  actions?: React.ReactNode;
}

/** Renders the citizen profile identity section with optional actions. */
export const ProfileIdentityBlock: React.FC<ProfileIdentityBlockProps> = ({
  identity,
  avatarSize = 40,
  actions,
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <UserAvatar username={identity.username} avatarUrl={identity.avatarUrl} size={avatarSize} />
        <Box>
          <Typography variant="h6" component="div">
            {identity.username}
          </Typography>
          {identity.fullname ? (
            <Typography variant="body2" color="text.secondary">
              {identity.fullname}
            </Typography>
          ) : null}
        </Box>
      </Box>
      {actions ? <Box>{actions}</Box> : null}
    </Box>
  );
};
